import React from 'react';
import { ScrollArea } from 'src/design/atoms/ScrollArea';
import { Navigation } from 'src/app/navigation/Navigation';

/** @registry Sidebar drawer body: a scrollable container around the route-aware Navigation tree. */
export const Sidebar: React.FC = () => (
  <ScrollArea style={{ flex: 1 }}>
    <Navigation />
  </ScrollArea>
);
